import { useLocation } from 'react-router-dom';
import { isConsumerApp } from '../util/Helpers';
import { routeNames } from '../util/Constants';

export default function useMarketplaceTiming() {
  const { pathname } = useLocation();
  return (
    isConsumerApp() && pathname.replace(/\/+$/, '') === routeNames.restaurants
  );
}
